import {
  TABLE_2_DOMAIN_SEQUENCE,
  TABLE_2_INVENTORY_BY_DOMAIN,
  TABLE_2_INVENTORY_ITEMS,
} from './masterTablesData';

const MAX_SEQUENCE_INDEX = Number.MAX_SAFE_INTEGER;

export const INVENTORY_DOMAIN_SEQUENCE = TABLE_2_DOMAIN_SEQUENCE;
export const INVENTORY_ITEMS_BY_DOMAIN = TABLE_2_INVENTORY_BY_DOMAIN;

const normalizeSequenceValue = (value = '') =>
  String(value).trim().replace(/\s+/g, ' ').toLowerCase();

const buildInventoryOrderMap = (items = []) => {
  const orderMap = new Map();

  items.forEach((item, index) => {
    const key = [normalizeSequenceValue(item.name), normalizeSequenceValue(item.typeVariant)].join('::');

    if (!orderMap.has(key)) {
      orderMap.set(key, index);
    }
  });

  return orderMap;
};

const INVENTORY_ORDER_LOOKUP = Object.fromEntries(
  Object.entries(INVENTORY_ITEMS_BY_DOMAIN).map(([domain, items]) => [domain, buildInventoryOrderMap(items)])
);

export function getInventoryMasterIndex(domain, name, typeVariant) {
  const domainLookup = INVENTORY_ORDER_LOOKUP[domain];

  if (!domainLookup) {
    return MAX_SEQUENCE_INDEX;
  }

  const key = [normalizeSequenceValue(name), normalizeSequenceValue(typeVariant)].join('::');

  return domainLookup.get(key) ?? MAX_SEQUENCE_INDEX;
}

export function sortInventoryItemsByMasterSequence(items = [], domain) {
  return [...items]
    .map((item, index) => ({
      item,
      index,
      masterIndex: getInventoryMasterIndex(domain, item?.name, item?.typeVariant),
    }))
    .sort((left, right) => {
      if (left.masterIndex !== right.masterIndex) {
        return left.masterIndex - right.masterIndex;
      }

      return left.index - right.index;
    })
    .map(({ item }) => item);
}

export { TABLE_2_INVENTORY_ITEMS };
